module.exports = __webpack_public_path__ + "img/header_dsk.0d33541.webp";